import { useQuery } from '@tanstack/react-query';
import { ApiRequestOptions, request } from '../utils/api';
import { buildApiQueryKey } from '../utils/auth';

type UseApiQueryProps<TData> = {
  queryKey: unknown[];
  request: ApiRequestOptions;
  enabled?: boolean;
  retry?: boolean | number;
};

export function useApiQuery<TData>({
  queryKey,
  request: requestOptions,
  enabled = true,
  retry,
}: UseApiQueryProps<TData>) {
  const scopedQueryKey = buildApiQueryKey(queryKey);

  return useQuery({
    queryKey: scopedQueryKey,
    enabled,
    retry,
    queryFn: () => request<TData>(requestOptions),
  });
}
